var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCipa4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 391,
    height: 314,
    viewBox: "0 0 391 314",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M272.549 103.37L389.695 125.478L347.836 85.1182H272.549V103.37Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105.287 233.644C92.0508 244.496 69.8125 258.683 41.2166 259.556C38.4938 259.634 4.94749 260.325 0.961007 247.649C-1.65756 239.35 10.2498 231.156 27.6939 209.947C41.373 193.323 50.7399 178.094 56.6805 167.411",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M105.287 233.644C92.0508 244.496 69.8125 258.683 41.2166 259.556C38.4938 259.634 4.94749 260.325 0.961007 247.649C-1.65756 239.35 10.2498 231.156 27.6939 209.947C41.373 193.323 50.7399 178.094 56.6805 167.411",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M163.014 30.9918C93.0419 44.0977 19.7089 170.649 69.0709 253.245C111.619 324.441 221.039 322.304 284.054 294.972C338.549 271.327 385.423 217.106 375.04 197.655C367.731 183.989 332.595 188.393 304.13 194.242C304.586 181.019 304.208 165.581 302.098 148.502C299.622 128.452 295.362 111.073 290.894 96.8599C284.64 86.1511 263.965 53.9076 222.602 38.3525C217.417 36.3983 189.043 26.1195 163.027 30.9918H163.014Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M100.138 178.161H100.152C115.167 178.161 127.34 165.988 127.34 150.972V146.048C127.34 131.032 115.167 118.859 100.152 118.859H100.138C85.1225 118.859 72.9496 131.032 72.9496 146.048V150.972C72.9496 165.988 85.1225 178.161 100.138 178.161Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5317 164.395C104.295 164.395 109.778 156.603 109.778 146.99C109.778 137.377 104.295 129.585 97.5317 129.585C90.7684 129.585 85.2856 137.377 85.2856 146.99C85.2856 156.603 90.7684 164.395 97.5317 164.395Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M101.668 124.347L97.0044 138.104L112.976 135.485L101.668 124.347Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M149.783 179.661H149.796C164.812 179.661 176.985 167.488 176.985 152.472V147.548C176.985 132.532 164.812 120.359 149.796 120.359H149.783C134.767 120.359 122.594 132.532 122.594 147.548V152.472C122.594 167.488 134.767 179.661 149.783 179.661Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M147.184 165.905C153.947 165.905 159.43 158.112 159.43 148.5C159.43 138.887 153.947 131.095 147.184 131.095C140.421 131.095 134.938 138.887 134.938 148.5C134.938 158.112 140.421 165.905 147.184 165.905Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M151.307 125.856L146.643 139.614L162.615 136.995L151.307 125.856Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M173.201 99.0858L151.861 95.1999C147.727 94.4471 143.765 97.1881 143.013 101.322L142.688 103.104C141.935 107.237 144.676 111.199 148.81 111.952L170.15 115.838C174.284 116.59 178.246 113.849 178.999 109.715L179.323 107.934C180.076 103.8 177.335 99.8385 173.201 99.0858Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8008 109.895L109.218 105.996C113.331 105.247 116.057 101.306 115.309 97.193L114.97 95.3345C114.221 91.2219 110.28 88.495 106.168 89.2439L84.7504 93.1437C80.6377 93.8926 77.9109 97.8337 78.6597 101.946L78.9981 103.805C79.747 107.917 83.6881 110.644 87.8008 109.895Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M268.11 91.9572C294.126 93.8723 326.018 99.2658 360.333 112.45C370.912 116.514 380.695 120.931 389.671 125.464C389.476 117.14 387.548 110.6 385.086 105.48C370.977 76.1155 324.585 62.8924 269.243 70.1749C268.865 77.4313 268.488 84.6878 268.11 91.9442V91.9572Z",
    fill: "#5B5BD8",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M101.567 69.0955C122.033 15.9294 178.938 -10.6472 226.372 5.10335C265.052 17.9487 292.462 57.3054 292.397 102.303C262.85 91.9721 226.711 81.9538 184.918 75.6614C154.316 71.0626 126.254 69.2909 101.567 69.0955Z",
    fill: "#5B5BD8",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M131.879 55.508C136.192 36.6699 154.274 27.9023 166.038 32.6183C174.662 36.0837 180.59 47.0921 179.717 59.4163C163.771 58.1135 147.825 56.8108 131.879 55.508Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M108.737 53.9834C132.395 55.7943 156.053 57.6051 179.725 59.416C189.587 58.5301 196.583 63.7542 196.974 68.7699C197.286 72.7303 193.443 76.0523 192.453 76.847",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M333.256 180.348L157.911 249.737L171.817 284.879L347.163 215.49L333.256 180.348Z",
    fill: "#5B5BD8",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M316.93 187.429L322.78 202.215",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M302.784 193.276L308.633 208.05",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M288.473 198.675L294.323 213.461",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M274.204 204.208L280.053 218.994",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M259.897 209.667L265.746 224.453",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M245.649 215.245L251.498 230.019",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M231.575 221.263L237.424 236.049",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M217.317 226.786L223.166 241.573",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M203.375 233.157L209.225 247.944",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M189.424 239.515L195.274 254.288",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M175.125 244.97L180.975 259.743",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M194.981 192.417C201.234 225.925 221.649 251.107 247.821 257.439C262.504 260.995 284.117 260.201 289.145 249.987C292.376 243.434 287.308 236.047 275.088 213.457C265.539 195.792 258.178 180.979 253.241 170.739",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M194.981 192.417C201.234 225.925 221.649 251.107 247.821 257.439C262.504 260.995 284.117 260.201 289.145 249.987C292.376 243.434 287.308 236.047 275.088 213.457C265.539 195.792 258.178 180.979 253.241 170.739",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M122.936 166.673C100.425 168.028 75.3332 171.428 74.0434 180.925C73.5093 184.899 77.3004 188.625 80.2316 191.491C96.4381 207.371 120.513 201.34 125.998 199.815",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M122.936 166.673C100.425 168.028 75.3332 171.428 74.0434 180.925C73.5093 184.899 77.3004 188.625 80.2316 191.491C96.4381 207.371 120.513 201.34 125.998 199.815",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M122.312 186.526C118.3 187.412 113.857 188.103 109.024 188.389C94.7979 189.223 82.7993 186.24 74.1489 183.048",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCipa4);
export default __webpack_public_path__ + "static/media/cipa4.f1978511750dbd422886e3a28aa4be4d.svg";
export { ForwardRef as ReactComponent };